(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["./requests-generator"], factory);
  } else if (typeof exports !== "undefined") {
    factory(require("./requests-generator"));
  } else {
    var mod = {
      exports: {}
    };
    factory(global.requestsGenerator);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_requestsGenerator) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  _requestsGenerator = _interopRequireDefault(_requestsGenerator);

  var isAvailable = function isAvailable(states) {
    (0, _requestsGenerator.default)(function () {
      return states.onSuccess();
    }, states.onError);
  };

  var getVersion = function getVersion(states) {
    (0, _requestsGenerator.default)(function (response) {
      try {
        states.onSuccess(JSON.parse(response).setappVersion);
      } catch (e) {
        states.onSuccess();
      }
    }, states.onError);
  };

  module.exports = {
    isAvailable: isAvailable,
    getVersion: getVersion
  };
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC5qcyJdLCJuYW1lcyI6WyJpc0F2YWlsYWJsZSIsInN0YXRlcyIsIm9uU3VjY2VzcyIsIm9uRXJyb3IiLCJnZXRWZXJzaW9uIiwicmVzcG9uc2UiLCJKU09OIiwicGFyc2UiLCJzZXRhcHBWZXJzaW9uIiwiZSIsIm1vZHVsZSIsImV4cG9ydHMiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFFQSxNQUFNQSxXQUFXLEdBQUcsU0FBZEEsV0FBYyxDQUFDQyxNQUFELEVBQVk7QUFDOUIsb0NBQWE7QUFBQSxhQUFNQSxNQUFNLENBQUNDLFNBQVAsRUFBTjtBQUFBLEtBQWIsRUFBdUNELE1BQU0sQ0FBQ0UsT0FBOUM7QUFDRCxHQUZEOztBQUlBLE1BQU1DLFVBQVUsR0FBRyxTQUFiQSxVQUFhLENBQUNILE1BQUQsRUFBWTtBQUM3QixvQ0FBYSxVQUFDSSxRQUFELEVBQWM7QUFDekIsVUFBSTtBQUNGSixRQUFBQSxNQUFNLENBQUNDLFNBQVAsQ0FBaUJJLElBQUksQ0FBQ0MsS0FBTCxDQUFXRixRQUFYLEVBQXFCRyxhQUF0QztBQUNELE9BRkQsQ0FFRSxPQUFPQyxDQUFQLEVBQVU7QUFDVlIsUUFBQUEsTUFBTSxDQUFDQyxTQUFQO0FBQ0Q7QUFDRixLQU5ELEVBTUdELE1BQU0sQ0FBQ0UsT0FOVjtBQU9ELEdBUkQ7O0FBVUFPLEVBQUFBLE1BQU0sQ0FBQ0MsT0FBUCxHQUFpQjtBQUNmWCxJQUFBQSxXQUFXLEVBQVhBLFdBRGU7QUFFZkksSUFBQUEsVUFBVSxFQUFWQTtBQUZlLEdBQWpCIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHNlbmRSZXF1ZXN0cyBmcm9tICcuL3JlcXVlc3RzLWdlbmVyYXRvcic7XG5cbmNvbnN0IGlzQXZhaWxhYmxlID0gKHN0YXRlcykgPT4ge1xuICBzZW5kUmVxdWVzdHMoKCkgPT4gc3RhdGVzLm9uU3VjY2VzcygpLCBzdGF0ZXMub25FcnJvcik7XG59O1xuXG5jb25zdCBnZXRWZXJzaW9uID0gKHN0YXRlcykgPT4ge1xuICBzZW5kUmVxdWVzdHMoKHJlc3BvbnNlKSA9PiB7XG4gICAgdHJ5IHtcbiAgICAgIHN0YXRlcy5vblN1Y2Nlc3MoSlNPTi5wYXJzZShyZXNwb25zZSkuc2V0YXBwVmVyc2lvbik7XG4gICAgfSBjYXRjaCAoZSkge1xuICAgICAgc3RhdGVzLm9uU3VjY2VzcygpO1xuICAgIH1cbiAgfSwgc3RhdGVzLm9uRXJyb3IpO1xufTtcblxubW9kdWxlLmV4cG9ydHMgPSB7XG4gIGlzQXZhaWxhYmxlLFxuICBnZXRWZXJzaW9uLFxufTtcbiJdfQ==